import { useState, useEffect, useRef, useCallback } from 'react';

const projects = [
  {
    title: 'Holiday Gala Event',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_6075e766cb4846968d0b2bb83fd59f1c~mv2.jpg/v1/fill/w_600,h_900,q_90/fcaee1_6075e766cb4846968d0b2bb83fd59f1c~mv2.jpg',
    size: 'Corporate Event',
    completion: '2023'
  },
  {
    title: 'Rooftop Corporate Dinner',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_cc8bb3c045964bb590dbd4103de22998~mv2.jpg/v1/fill/w_600,h_450,q_90/fcaee1_cc8bb3c045964bb590dbd4103de22998~mv2.jpg',
    size: 'Executive Event',
    completion: '2023'
  },
  {
    title: 'Fashion Show Reception',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_6fe6e44241764f1cb21f1bdeb0bb072b~mv2.jpg/v1/fill/w_600,h_400,q_90/fcaee1_6fe6e44241764f1cb21f1bdeb0bb072b~mv2.jpg',
    size: 'Runway Event',
    completion: '2023'
  },
  {
    title: 'Corporate Networking Event',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_814e1d26dbff41efbfd5debc6d8dfa96~mv2.jpg/v1/fill/w_600,h_800,q_90/fcaee1_814e1d26dbff41efbfd5debc6d8dfa96~mv2.jpg',
    size: 'Business Event',
    completion: '2023'
  },
  {
    title: 'Elegant Gala Dinner',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_3e47dc37fe9a47428e491ddba3dc6d6e~mv2.jpg/v1/fill/w_600,h_450,q_90/fcaee1_3e47dc37fe9a47428e491ddba3dc6d6e~mv2.jpg',
    size: 'Gala Event',
    completion: '2023'
  },
  {
    title: 'Corporate Conference',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_721feb7707cc40f2b946d659aa5a81b3~mv2.jpg/v1/fill/w_600,h_400,q_90/fcaee1_721feb7707cc40f2b946d659aa5a81b3~mv2.jpg',
    size: 'Conference',
    completion: '2023'
  },
  {
    title: 'Intimate Dinner Setup',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_c2dfacc3d81344f685a49d163307ae12~mv2.jpg/v1/fill/w_600,h_400,q_90/fcaee1_c2dfacc3d81344f685a49d163307ae12~mv2.jpg',
    size: 'Private Dinner',
    completion: '2023'
  },
  {
    title: 'Corporate Presentation',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_4e327f14b4144ebc8b866fe47e4151b1~mv2.jpg/v1/fill/w_600,h_400,q_90/fcaee1_4e327f14b4144ebc8b866fe47e4151b1~mv2.jpg',
    size: 'Business Event',
    completion: '2023'
  },
  {
    title: 'Executive Dinner',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_7a9bbf1b2c304b49b8db413ed3861ecc~mv2.jpg/v1/fill/w_600,h_400,q_90/fcaee1_7a9bbf1b2c304b49b8db413ed3861ecc~mv2.jpg',
    size: 'Private Event',
    completion: '2023'
  },
  {
    title: 'Holiday Party Setup',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_5685f5d67a5d43e09bd2b77302d78523~mv2.jpg/v1/fill/w_600,h_400,q_90/fcaee1_5685f5d67a5d43e09bd2b77302d78523~mv2.jpg',
    size: 'Holiday Event',
    completion: '2023'
  },
  {
    title: 'Corporate Gala',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_ddd66f5fc3114fe3953ea3c3f54e4490~mv2.jpg/v1/fill/w_600,h_400,q_90/fcaee1_ddd66f5fc3114fe3953ea3c3f54e4490~mv2.jpg',
    size: 'Corporate Gala',
    completion: '2023'
  },
  {
    title: 'Elegant Table Setting',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_bebbce28c61a4fa084d0cd6ff360ffe4~mv2.jpg/v1/fill/w_600,h_400,q_90/fcaee1_bebbce28c61a4fa084d0cd6ff360ffe4~mv2.jpg',
    size: 'Fine Dining',
    completion: '2023'
  },
  {
    title: 'Corporate Celebration',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_9e6485ef2af6400cad38dd191b8f95fc~mv2.jpg/v1/fill/w_600,h_400,q_90/fcaee1_9e6485ef2af6400cad38dd191b8f95fc~mv2.jpg',
    size: 'Corporate Event',
    completion: '2023'
  },
  {
    title: 'Keynote Speaker Event',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_81f86a626aac443dbe8eac14d8efc8f6~mv2.jpg/v1/fill/w_600,h_400,q_90/fcaee1_81f86a626aac443dbe8eac14d8efc8f6~mv2.jpg',
    size: 'Conference',
    completion: '2023'
  },
  {
    title: 'Gala Dinner Setup',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_4db50e9d3006406895967108b7eabaed~mv2.jpg/v1/fill/w_600,h_400,q_90/fcaee1_4db50e9d3006406895967108b7eabaed~mv2.jpg',
    size: 'Gala Event',
    completion: '2023'
  },
  {
    title: 'Event Afterparty',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_b324a52090564d83bae03b560acc97af~mv2.jpg/v1/fill/w_600,h_1000,q_90/fcaee1_b324a52090564d83bae03b560acc97af~mv2.jpg',
    size: 'After Party',
    completion: '2023'
  },
  {
    title: 'Corporate Speaker',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_2301b67bf3f64321835694e27a919a54~mv2.jpg/v1/fill/w_600,h_900,q_90/fcaee1_2301b67bf3f64321835694e27a919a54~mv2.jpg',
    size: 'Business Event',
    completion: '2023'
  },
  {
    title: 'Fashion Show Presentation',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_d337c02679684ea2b05405ef6ed785a4~mv2.jpg/v1/fill/w_600,h_800,q_90/fcaee1_d337c02679684ea2b05405ef6ed785a4~mv2.jpg',
    size: 'Runway Event',
    completion: '2023'
  },
  {
    title: 'Executive Presentation',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_6bb341c2be3a45bd94291ac91f10f5e6~mv2.jpg/v1/fill/w_600,h_800,q_90/fcaee1_6bb341c2be3a45bd94291ac91f10f5e6~mv2.jpg',
    size: 'Corporate Event',
    completion: '2023'
  },
  {
    title: 'Elegant Gala Table',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_0eb4051f02884756836be249f2c2c05c~mv2.jpg/v1/fill/w_600,h_400,q_90/fcaee1_0eb4051f02884756836be249f2c2c05c~mv2.jpg',
    size: 'Gala Dinner',
    completion: '2023'
  },
  {
    title: 'Corporate Dinner Event',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_bde5b468b71e417ca979ad3329858a3e~mv2.jpg/v1/fill/w_600,h_400,q_90/fcaee1_bde5b468b71e417ca979ad3329858a3e~mv2.jpg',
    size: 'Corporate Dinner',
    completion: '2023'
  },
  {
    title: 'Luxury Gala Setup',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_d126a1ff7bfc44b98a96b9fe70d47397~mv2.jpg/v1/fill/w_600,h_400,q_90/fcaee1_d126a1ff7bfc44b98a96b9fe70d47397~mv2.jpg',
    size: 'Luxury Event',
    completion: '2023'
  },
  {
    title: 'Intimate Dinner Decor',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_e16059d1f2384f9cb903a5fff2a09ed4~mv2.jpg/v1/fill/w_600,h_400,q_90/fcaee1_e16059d1f2384f9cb903a5fff2a09ed4~mv2.jpg',
    size: 'Private Dinner',
    completion: '2023'
  },
  {
    title: 'Corporate Awards Night',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_39525b1014ef4b689e8e5da5d6726ccb~mv2.jpg/v1/fill/w_600,h_400,q_90/fcaee1_39525b1014ef4b689e8e5da5d6726ccb~mv2.jpg',
    size: 'Awards Event',
    completion: '2023'
  },
  {
    title: 'Gala Centerpiece',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_23070aa7b46142ce9b2c6b31dbdc9f99~mv2.jpg/v1/fill/w_600,h_400,q_90/fcaee1_23070aa7b46142ce9b2c6b31dbdc9f99~mv2.jpg',
    size: 'Gala Event',
    completion: '2023'
  },
  {
    title: 'Elegant Dinner Setting',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_06ea8b6db3774a93a68925dc08f6fd8d~mv2.jpg/v1/fill/w_600,h_750,q_90/fcaee1_06ea8b6db3774a93a68925dc08f6fd8d~mv2.jpg',
    size: 'Fine Dining',
    completion: '2023'
  },
  {
    title: 'Corporate Cocktail Event',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_f88a29cd7ebe4aac869bbf31ce8a601c~mv2.jpg/v1/fill/w_600,h_800,q_90/fcaee1_f88a29cd7ebe4aac869bbf31ce8a601c~mv2.jpg',
    size: 'Cocktail Party',
    completion: '2023'
  },
  {
    title: 'Luxury Table Decor',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_15786b03012541eaa4c8ba1f368fa0ff~mv2.jpg/v1/fill/w_600,h_750,q_90/fcaee1_15786b03012541eaa4c8ba1f368fa0ff~mv2.jpg',
    size: 'Private Event',
    completion: '2023'
  },
  {
    title: 'Holiday Gala Decor',
    location: 'Toronto, ON',
    image: 'https://static.wixstatic.com/media/fcaee1_0c5f56b4b532457c841ea834dc175d34~mv2.jpg/v1/fill/w_600,h_750,q_90/fcaee1_0c5f56b4b532457c841ea834dc175d34~mv2.jpg',
    size: 'Holiday Event',
    completion: '2023'
  }
];

// Height patterns for masonry effect — cycles through to create visual variety
const heightPatterns = [
  'row-span-2', // tall
  'row-span-1', // short
  'row-span-1', // short
  'row-span-1', // short
  'row-span-2', // tall
  'row-span-1', // short
];

function useInView(threshold = 0.1) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);

  return { ref, visible };
}

export default function Portfolio() {
  const [visibleCount, setVisibleCount] = useState(9);
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);
  const header = useInView(0.15);
  const grid = useInView(0.05);

  const displayedProjects = projects.slice(0, visibleCount);

  const openLightbox = (index: number) => {
    setLightboxIndex(index);
  };

  const closeLightbox = () => {
    setLightboxIndex(null);
  };

  const goToPrev = useCallback(() => {
    setLightboxIndex((prev) => {
      if (prev === null) return null;
      return prev === 0 ? projects.length - 1 : prev - 1;
    });
  }, []);

  const goToNext = useCallback(() => {
    setLightboxIndex((prev) => {
      if (prev === null) return null;
      return prev === projects.length - 1 ? 0 : prev + 1;
    });
  }, []);

  // Keyboard navigation
  useEffect(() => {
    if (lightboxIndex === null) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') goToPrev();
      if (e.key === 'ArrowRight') goToNext();
    };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [lightboxIndex, goToPrev, goToNext]);

  return (
    <section
      id="portfolio"
      className="relative py-28 md:py-36 overflow-hidden bg-gradient-to-br from-[#1a1a1a] via-[#141414] to-[#0d0d0d]"
    >
      {/* Ambient warm glows */}
      <div className="absolute top-0 right-1/4 w-[700px] h-[700px] rounded-full blur-[160px] pointer-events-none" style={{ background: 'rgba(213,186,107,0.04)' }} />
      <div className="absolute bottom-0 left-1/4 w-[500px] h-[500px] rounded-full blur-[140px] pointer-events-none" style={{ background: 'rgba(213,186,107,0.03)' }} />
      <div className="absolute top-1/2 left-0 w-[300px] h-[600px] rounded-full blur-[120px] pointer-events-none" style={{ background: 'rgba(213,186,107,0.02)' }} />

      {/* Geometric shapes */}
      <div className="absolute top-24 left-12 w-32 h-32 border border-white/[0.03] rotate-45 pointer-events-none" />
      <div className="absolute bottom-40 right-16 w-20 h-20 rotate-12 rounded-xl pointer-events-none" style={{ borderWidth: '1px', borderStyle: 'solid', borderColor: 'rgba(213,186,107,0.05)' }} />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header — consistent with other sections */}
        <div
          ref={header.ref}
          className={`text-center mb-20 md:mb-24 transition-all duration-1000 ${
            header.visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-12 h-[2px]" style={{ background: 'linear-gradient(to right, transparent, #D5BA6B)' }} />
            <span className="text-[11px] uppercase tracking-[0.3em] font-semibold" style={{ color: '#D5BA6B' }}>
              Our Work
            </span>
            <div className="w-12 h-[2px]" style={{ background: 'linear-gradient(to left, transparent, #D5BA6B)' }} />
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5 tracking-tight">
            Our Portfolio
          </h2>
          <p className="text-base text-white/50 leading-relaxed font-light max-w-2xl mx-auto">
            A curated collection of exceptional events we&apos;ve brought to life — from elegant corporate galas and executive dinners to high-profile fashion shows and intimate celebrations, each reflecting our commitment to flawless execution.
          </p>
        </div>

        {/* Masonry-style grid */}
        <div
          ref={grid.ref}
          className="grid grid-cols-2 md:grid-cols-3 auto-rows-[180px] md:auto-rows-[200px] gap-3 md:gap-4 mb-14"
        >
          {displayedProjects.map((project, index) => {
            const pattern = heightPatterns[index % heightPatterns.length];
            return (
              <div
                key={index}
                onClick={() => openLightbox(index)}
                className={`group relative overflow-hidden rounded-xl ${pattern} transition-all duration-700 cursor-pointer ${
                  grid.visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
                }`}
                style={{ transitionDelay: `${Math.min(index * 60, 500)}ms` }}
              >
                <div className="w-full h-full">
                  <img
                    src={project.image}
                    alt={project.title}
                    title={`MGroup Global - ${project.title}`}
                    className="w-full h-full object-cover object-top grayscale transition-all duration-700 group-hover:scale-110"
                  />
                </div>

                {/* Hover overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500 flex flex-col justify-end p-4 md:p-5">
                  {/* Descriptions hidden - to be updated later */}
                </div>

                {/* Expand icon on hover */}
                <div className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-black/40 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-all duration-400 pointer-events-none">
                  <i className="ri-fullscreen-line text-white text-sm" />
                </div>

                {/* Subtle border */}
                <div className="absolute inset-0 border border-white/[0.06] rounded-xl pointer-events-none group-hover:border-[#D5BA6B]/20 transition-colors duration-500" />
              </div>
            );
          })}
        </div>

        {/* Load more button */}
        {visibleCount < projects.length && (
          <div
            className={`flex justify-center transition-all duration-700 ${
              grid.visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
            style={{ transitionDelay: '600ms' }}
          >
            <button
              onClick={() => setVisibleCount(prev => prev + 9)}
              className="group/btn inline-flex items-center gap-3 border font-semibold text-sm px-8 py-3 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 whitespace-nowrap cursor-pointer"
              style={{ borderColor: 'rgba(213,186,107,0.4)', color: '#D5BA6B' }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#D5BA6B'; e.currentTarget.style.backgroundColor = '#D5BA6B'; e.currentTarget.style.color = '#1a1510'; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(213,186,107,0.4)'; e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#D5BA6B'; }}
            >
              <span>View More</span>
              <span className="w-8 h-8 flex items-center justify-center rounded-full transition-colors duration-300" style={{ backgroundColor: 'rgba(213,186,107,0.1)' }}>
                <i className="ri-arrow-down-line text-base" />
              </span>
            </button>
          </div>
        )}

        {visibleCount >= projects.length && (
          <div className="flex justify-center">
            <div className="w-16 h-[2px]" style={{ background: 'linear-gradient(to right, transparent, rgba(213,186,107,0.4), transparent)' }} />
          </div>
        )}
      </div>

      {/* Lightbox Overlay */}
      {lightboxIndex !== null && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center"
          onClick={closeLightbox}
        >
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/95 backdrop-blur-md animate-[fadeIn_0.2s_ease-out]" />

          {/* Close button */}
          <button
            onClick={(e) => { e.stopPropagation(); closeLightbox(); }}
            className="absolute top-5 right-5 z-10 w-11 h-11 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors duration-300 cursor-pointer"
          >
            <i className="ri-close-line text-white text-xl" />
          </button>

          {/* Counter */}
          <div className="absolute top-6 left-6 z-10 text-white/50 text-sm font-medium">
            {lightboxIndex + 1} / {projects.length}
          </div>

          {/* Previous button */}
          <button
            onClick={(e) => { e.stopPropagation(); goToPrev(); }}
            className="absolute left-4 md:left-8 z-10 w-12 h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors duration-300 cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-white text-2xl" />
          </button>

          {/* Next button */}
          <button
            onClick={(e) => { e.stopPropagation(); goToNext(); }}
            className="absolute right-4 md:right-8 z-10 w-12 h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors duration-300 cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-white text-2xl" />
          </button>

          {/* Image container */}
          <div
            className="relative z-10 max-w-[90vw] max-h-[85vh] flex flex-col items-center animate-[scaleIn_0.25s_ease-out]"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={projects[lightboxIndex].image}
              alt={projects[lightboxIndex].title}
              className="max-w-full max-h-[78vh] object-contain rounded-lg shadow-2xl"
            />
            {/* Caption hidden - to be updated later */}
          </div>
        </div>
      )}
    </section>
  );
}
